import React from 'react';

export default function (props: any) {
  const {
    viewBox: { x, y },
  } = props;
  return (
    <image
      href="/images/outlier.png"
      height="20"
      width="20"
      x={x - 5}
      y={y - 5}
    />
  );
}
